import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/401_error.svg'


const _hoisted_1 = {
  class: "container",
  role: "main",
  "aria-label": "Unauthorized-Access Page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
    /*#__PURE__*/_createElementVNode("figure", null, [
      /*#__PURE__*/_createCommentVNode(" Image downloaded from ShutterStock and color changed by Marketing dept "),
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "w-50 p-3",
        alt: "401 Error Image"
      })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Unauthorized Access!", -1 /* HOISTED */)
const _hoisted_6 = { class: "text-secondary mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, " You will be logged out in " + _toDisplayString($setup.counter) + " seconds. ", 1 /* TEXT */)
      ])
    ])
  ]))
}